<script setup lang="ts">
import { onMounted } from 'vue'
import { ElConfigProvider } from 'element-plus'
import es from 'element-plus/es/locale/lang/es'
import dayjs from 'dayjs'
// Month and weekday names in the date pickers come from dayjs, not from the
// Element Plus locale: without this file they render in English.
import 'dayjs/locale/es'

import { useTheme } from '@/composables/useTheme'

dayjs.locale('es')

const { initTheme } = useTheme()

// Applied on mount rather than at module load so the DOM is guaranteed to
// exist. The flash before this runs is avoided by the background color set
// on body in main.css.
onMounted(initTheme)
</script>

<template>
  <!-- Element Plus ships its own strings for pagination, date pickers and
       dialogs. The Spanish locale keeps the whole interface in one language
       without translating each component by hand. -->
  <ElConfigProvider :locale="es">
    <RouterView />
  </ElConfigProvider>
</template>
